export const isProductionMode = import.meta.env.MODE === 'production';

export const isDevelopmentMode = import.meta.env.MODE === 'development';
